export { default } from "@casino/client/utils/getSiteInfo";
